var alignmentStyle = {"alignLeft":"adHfv","textWrapNowrap":"fXEV8","alignRight":"FTv90","alignCenter":"p4KGa","sizeFullWidth":"GwWb9","renderedInTable":"ABpdR","sizeOriginal":"He48R","sizeContent":"UMt0l","sizeSmall":"keLRS","sizeSmallCenter":"i3yAN","flex":"RU6-l","LEFT":"FyTdJ","CENTER":"Cn4W9","RIGHT":"VrN-L","AUTO":"_5TXqj","JUSTIFY":"ayrFV"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-0abea621.js.map
